import PageTitleComponent from "../PageTitle"
import BrandList from "./Actions/BrandList"

const Brands = () => {
    return (<div>
        <PageTitleComponent title="Brands"/>
        <BrandList/>
    </div>)
}

export default Brands